import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;

  .MuiTextField-root {
    width: 100%;
  }

  .MuiInputBase-root {
    height: 56px;
    background-color: #FFFFFF;
    border-radius: 8px;

    &:hover {
      background-color: #F9F9F9;
    }

    &.Mui-disabled {
      background-color: #F5F5F5;
    }
  }

  .MuiInputLabel-root {
    color: #666;
    font-weight: 500;
    font-size: 1rem;

    &.Mui-focused {
      color: #89BD23;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: #E0E0E0;
    border-width: 1px;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #BDBDBD;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #89BD23;
    border-width: 2px;
  }

  .MuiInputBase-input {
    padding: 16.5px 14px;
  }
`;
